import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const category = (theme: ExactTheme) =>
  css({
    height: "35px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  });

export const backButton = css`
  padding: 0 10px;
  font-size: 14px;
  height: 35px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const backButtonText = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const list = css`
  max-height: 265px;
  overflow: auto;
`;

export const root = css({
  flexShrink: 0,
});

export const errorText = (theme: ExactTheme) => css`
  color: ${theme.colors.red[500]};
  font-size: 14px;
`;

export const refetchButton = (theme: ExactTheme) => css`
  color: ${theme.colors.blue[500]};
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
`;

export const errorContainer = (theme: ExactTheme) => css`
  font-size: 14px;
  padding-left: 10px;
`;

export const loadingContainer = (theme: ExactTheme) => css`
  font-size: 14px;
  padding-left: 10px;
`;

export const categoryInner =
  ({ isActive }: { isActive: boolean }) =>
  (theme: ExactTheme) =>
    css({
      color: isActive ? theme.colorsV2.grey[900] : theme.colorsV2.blue[500],
      fontWeight: isActive ? "500" : "400",
      fontSize: "14px",
      height: "100%",
      cursor: "pointer",
      padding: "0 10px",
      display: "flex",
      alignItems: "center",
      flexGrow: 1,
      gap: 5,
      ":hover": {
        color: isActive ? theme.colorsV2.grey[900] : theme.colorsV2.blue[600],
        "[data-text]": {
          textDecoration: "none",
        },
      },
    });

export const categoryText = ({ isActive }: { isActive: boolean }) =>
  css({
    textDecoration: isActive ? "none" : "underline",
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
  });

export const categoryIcon = css({
  textDecoration: "none",
});

export const categoryArrow = () => css`
  flex-shrink: 0;
  cursor: pointer;
`;
